var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasTopicMedia)?_c('TopicMediaPreview',{attrs:{"doc-path":_vm.selectedTopic.docPath,"doc-type":_vm.selectedTopic.docType,"video-class":"h400","video-height":'450',"iframe-height":600}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }